import { render, staticRenderFns } from "./PeopleDensityCount.vue?vue&type=template&id=13735c97&scoped=true"
import script from "./PeopleDensityCount.vue?vue&type=script&lang=js"
export * from "./PeopleDensityCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13735c97",
  null
  
)

export default component.exports